import React from "react";
import { Route, Redirect } from "react-router-dom";

const GuardedPublicRoute = ({ component: Component, auth, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      auth === null || !auth ? (
        <Component {...props} />
      ) : (
        <Redirect to="/asignacion" />
      )
    }
  />
);

export default GuardedPublicRoute;
